<template>
  <div
    :class="{
      [$style.slideComponent]: true,
      [$style.slideComponentNewDesign]: isNewDesign,
      [$style.isContactFormSlide]: isContactFormSlide,
      [$style.paddingLeftMedium]: slide.paddingLeft === 'medium',
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone,
      [$style.small]: el.is.small
    }"
  >
    <!-- LISA VIEW -->
    <LisaView
      :class="{ [$style.person]: true, [$style.personNewDesign]: isNewDesign }"
      :slideName="slide.slideName"
    />
    <div
      :class="$style.icons"
      v-if="isContactFormSlide && (el.is.phone || el.is.port)"
    >
      <div :class="[$style.iconDiv, $style.iconSmall]">
        <img
          :class="$style.img"
          src="@/assets/images/icon-ssl.svg"
          alt="ssl icon"
        />
      </div>
      <div :class="[$style.iconDiv, $style.iconSmall]">
        <img
          :class="$style.img"
          src="@/assets/images/icon-serverstandort.svg"
          alt="serverstandort icon"
        />
      </div>
      <div :class="[$style.iconDiv, $style.iconBig]">
        <img
          :class="$style.img"
          src="@/assets/images/icon-dsgvo.svg"
          alt="dsgvo icon"
        />
      </div>
    </div>
    <!-- FORM WRAPPER -->
    <FormWrapper :class="$style.form" @selected="$emit('selected')" />
  </div>
</template>

<script>
import LisaView from '@/components/LisaView.vue'
import FormWrapper from '@/components/FormWrapper.vue'
import store from '@/store'

export default {
  components: {
    LisaView,
    FormWrapper
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    slideNames() {
      return store.state.slideNames
    },
    slide() {
      return store.getters['slide']
    },
    isContactFormSlide() {
      return this.slide.slideName === this.slideNames.SLIDE_21
    },
    el() {
      return store.state.el
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.slideComponent {
  height: 713px;
  margin: 0 auto;
  padding-top: 6.44%;
  display: flex;
  background-color: $color_bg_dark;

  .person {
    width: 36.91%;
    margin-left: -2.51%;
  }

  // note: new design
  .personNewDesign {
    margin-left: 0;
  }

  .form {
    width: 780px;
    margin-left: auto;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
}
.slideComponentNewDesign {
  background-color: $color_bg_hausanker;
}
.isContactFormSlide {
  &.slideComponent {
    height: auto;
  }
  .icons {
    display: flex;
    align-items: center;
    align-self: center;
    height: 80px;
    padding-right: 20px;
    padding-left: 20px;
    // margin-left: auto;
    .iconDiv {
      // height: 100%;
      // margin-left: 20px;
      .img {
        height: 100%;
        display: inline-block;
      }
    }
    .iconDiv:not(:last-child) {
      margin-right: 15px;
    }
  }
}
.paddingLeftMedium {
  .form {
    padding-left: 200px;
  }
}

// note: LANDSCAPE
.land {
  .person {
    width: 40%;
  }
  .form {
    width: 60%;
  }
  &.paddingLeftMedium {
    .form {
      padding-left: 60px;
    }
  }
}

// note: PORTRAIT
.port {
  &.slideComponent {
    padding-top: 20px;
    height: auto;
    // min-height: 713px;
    flex-direction: column;
    .person {
      width: 100%;
      flex-direction: row-reverse;
      margin-left: 0px;
    }
    .form {
      width: 100%;
    }
    .icons {
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  &.paddingLeftMedium {
    .form {
      padding: 0px 50px;
    }
  }
}

// note: PHONE
.phone {
  &.slideComponent {
    height: auto;
    flex-direction: column;
    .form {
      width: 100%;
      padding: 0px;
      margin: 0 auto;
    }
    .person {
      width: 100%;
      flex-direction: column-reverse;
    }
    .icons {
      margin-top: 30px;
      margin-bottom: -10px;
    }
  }
}

// note: small
.small {
  &.slideComponent {
    .icons {
      height: auto;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: -30px;
      .iconDiv:not(:last-child) {
        margin-right: 3px;
      }
    }
  }
  .iconBig {
    img {
      max-width: 140px;
    }
  }
  .iconSmall {
    img {
      max-width: 70px;
    }
  }
}
</style>
